import { PROMO } from 'apps/promo/constants/EntryPoint';
import { NO_AUTH_VIEW } from 'apps/promo/constants/ServerConstants';
import ZendeskHelpArticlePage from 'apps/promo/pages/help/ZendeskHelpArticlePage';
import ZendeskHelpCategoryPage from 'apps/promo/pages/help/ZendeskHelpCategoryPage';
import ZendeskHelpPage from 'apps/promo/pages/help/ZendeskHelpPage';
import ZendeskHelpSectionPage from 'apps/promo/pages/help/ZendeskHelpSectionPage';
import ZendeskHelpMobileArticlePage from 'apps/promo/pages/help-mobile/ZendeskHelpMobileArticlePage';
import ZendeskHelpMobileCategoryPage from 'apps/promo/pages/help-mobile/ZendeskHelpMobileCategoryPage';
import ZendeskHelpMobilePage from 'apps/promo/pages/help-mobile/ZendeskHelpMobilePage';
import ZendeskHelpMobileSectionPage from 'apps/promo/pages/help-mobile/ZendeskHelpMobileSectionPage';
import { FOOTER_TYPE_DEFAULT, LANG_COUNTRY } from 'apps/promo/routes/routeConstant';

const helpNoAuth = [
    {
        path: [
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/section/:sectionId/article/:articleId`,
            '/help-mobile/category/:categoryId/section/:sectionId/article/:articleId',
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/section/:sectionId/article/:articleId/showChat`,
            '/help-mobile/category/:categoryId/section/:sectionId/article/:articleId/showChat',
        ],
        exact: true,
        component: ZendeskHelpMobileArticlePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        isPathWithoutFooter: false,
        stateOptions: {
            strapiApi: '/api/v1/zendesk-article/{:articleId}',
            strapiApiUseCache: true,
            entryPoint: PROMO,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'article',
            openChatInNoAuthZone: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isHelp: true,
            isHelpMobile: true,
        },
    },
    {
        path: [
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/section/:sectionId`,
            '/help-mobile/category/:categoryId/section/:sectionId',
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/section/:sectionId/showChat`,
            '/help-mobile/category/:categoryId/section/:sectionId/showChat',
        ],
        exact: true,
        component: ZendeskHelpMobileSectionPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        isPathWithoutFooter: false,
        stateOptions: {
            strapiApi: '/api/v1/zendesk-section/{:sectionId}',
            strapiApiUseCache: true,
            entryPoint: PROMO,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'section',
            openChatInNoAuthZone: false,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isHelp: true,
            isHelpMobile: true,
        },
    },
    {
        path: [
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId`,
            '/help-mobile/category/:categoryId',
            `/${LANG_COUNTRY}/help-mobile/category/:categoryId/showChat`,
            '/help-mobile/category/:categoryId/showChat',
        ],
        exact: true,
        component: ZendeskHelpMobileCategoryPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        isPathWithoutFooter: false,
        stateOptions: {
            strapiApi: '/api/v1/zendesk-category/{:categoryId}',
            strapiApiUseCache: true,
            entryPoint: PROMO,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'category',
            openChatInNoAuthZone: false,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isHelp: true,
            isHelpMobile: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help-mobile`, '/help-mobile', `/${LANG_COUNTRY}/help-mobile/showChat`, '/help-mobile/showChat'],
        exact: true,
        component: ZendeskHelpMobilePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        isPathWithoutFooter: false,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: true,
            entryPoint: PROMO,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'main',
            openChatInNoAuthZone: false,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isHelp: true,
            isHelpMobile: true,
        },
    },
    {
        path: [
            `/${LANG_COUNTRY}/help/category/:categoryId/section/:sectionId/article/:articleId`,
            '/help/category/:categoryId/section/:sectionId/article/:articleId',
        ],
        exact: true,
        component: ZendeskHelpArticlePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v1/zendesk-article/{:articleId}',
            strapiApiUseCache: true,
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'article',
            openChatInNoAuthZone: true,
        },
        renderOptions: {
            isHelp: true,
            hasChatButton: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help/category/:categoryId/section/:sectionId`, '/help/category/:categoryId/section/:sectionId'],
        exact: true,
        component: ZendeskHelpSectionPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v1/zendesk-section/{:sectionId}',
            strapiApiUseCache: true,
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'section',
            openChatInNoAuthZone: false,
        },
        renderOptions: {
            isHelp: true,
            hasChatButton: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help/category/:categoryId`, '/help/category/:categoryId'],
        exact: true,
        component: ZendeskHelpCategoryPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v1/zendesk-category/{:categoryId}',
            strapiApiUseCache: true,
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'category',
            openChatInNoAuthZone: false,
        },
        renderOptions: {
            isHelp: true,
            hasChatButton: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/help`, '/help'],
        exact: true,
        component: ZendeskHelpPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/zendesk-help-page',
            strapiApiUseCache: true,
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            pageName: 'zendesk',
            isZendeskHelp: true,
            zendeskHelpPage: 'main',
            openChatInNoAuthZone: false,
        },
        renderOptions: {
            isHelp: true,
            hasChatButton: true,
        },
    },
];

export default helpNoAuth;
